// Toggle button names that have on/off states in the HTML editor
export const toggleTools: readonly string[] = [
  'bold', 'italic', 'underline', 'strikethrough',
  'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'
] as const

// Kendo editor toolbar tools configuration
export const editorTools: readonly string[] = [
  'bold',
  'italic',
  'underline',
  'justifyLeft',
  'justifyCenter',
  'justifyRight',
  'justifyFull',
  'insertUnorderedList',
  'insertOrderedList',
  'indent',
  'outdent',
  'insertImage',
  'tableWizard',
  'createTable',
  'addRowAbove',
  'addRowBelow',
  'addColumnLeft',
  'addColumnRight',
  'deleteRow',
  'deleteColumn',
  'mergeCellsHorizontally',
  'mergeCellsVertically',
  'splitCellHorizontally',
  'splitCellVertically',
  'viewHtml',
  'formatting',
  'cleanFormatting',
  'copyFormat',
  'applyFormat',
  'foreColor',
  'backColor',
  'fontName',
  'fontSize',
] as const
